import styled from "styled-components";

export const Chapter = styled.p`
    text-align: justify;
    line-height: 1.15;
`;